import React from 'react';
import PropTypes from 'prop-types';

import onClickOutside from 'react-onclickoutside';

import graphUtils from '../../../global/utils/graphUtils';

import transitionStyles from '../transitionModuleStyles.css';

const NewGraphTransition = ({
  graphMouseX
  , graphMouseY
  , startNode
  , transition
}) => {
  let startX = startNode.authoring.x;
  let startY = startNode.authoring.y;

  let endX = graphMouseX;
  let endY = graphMouseY;

  const isEmpty = (
    !transition
  )

  let pathString;
  let pathEndMarker;

  if(!isEmpty) {
    pathString = graphUtils.getTransitionPath(startX, startY, endX, endY)
    pathEndMarker = graphUtils.getTransitionMarker(startX, startY, endX, endY)
  }

  const arrowRef = "arrow-new"; // annoying. these are defined in the top level SVG in ContentModuleGraph
  const transitionStyles = {
    // fill:'rgba(0,0,0,0.5)'
    fill: 'none'
    , stroke: 'magenta'
    , strokeWidth:'3'
    // , boxShadow: '6px 6px 28px -2px rgba(0,0,0,0.75)'
    // , filter: 'drop-shadow( -5px -5px 5px #000 )'
  }
  const transitionPointerStyles = {
    fill: 'none'
    , stroke: 'magenta'
    , strokeWidth: '3'
    // , boxShadow: '6px 6px 28px -2px rgba(0,0,0,0.75)'
    // , filter: 'drop-shadow( -5px -5px 5px #000 )'
  }

  if(isEmpty) {
    return null;
  } else {
    // console.log('render new transtition')
    return (
      <g>
        <path markerEnd={`url(#${arrowRef})`} style={transitionPointerStyles} d={pathEndMarker} />
        <path style={transitionStyles} d={pathString} />
      </g>
    )
  }
}

NewGraphTransition.propTypes = {
  graphMouseX: PropTypes.number
  , graphMouseY: PropTypes.number
  , startNode: PropTypes.object
  , transition: PropTypes.object.isRequired
}

NewGraphTransition.defaultProps = {
  graphMouseX: null
  , graphMouseY: null
  , startNode: null
}

export default onClickOutside(NewGraphTransition);



// WEBPACK FOOTER //
// modules/transition/components/NewGraphTransition.js.jsx